module.exports = __webpack_public_path__ + "static/media/playstore.e3ea015c.svg";